<template>
    <div>
        <custom-header :level="level" :text="text"></custom-header>
    </div>
</template>

<script>
import customHeader from "./custom-header";

export default {
  name: "kollecto-header",
  props: ["formElement"],
  data() {
    return {
      level: 3,
      text: "Overskrift"
    }
  },
  components: {
    "custom-header": customHeader
  },
  created() {
    if (this.formElement.dynamicTypeData.htmlHeaderTag) {
      this.level = this.formElement.dynamicTypeData.htmlHeaderTag.substring(2, 3);
    }
    this.text = this.formElement.label;
  }
};
</script>